export default {
  users: [],
  user: null,
  roles: [],
  pagination: {}
};
